module.exports = __webpack_public_path__ + "static/media/Icon feather-download-kn.4957dc3b.svg";